import { useEffect, useState } from "react";
import { Lock } from "lucide-react";

const ROLE_LABEL = { admin: "Admin", coach: "Coach", member: "Member", vendor: "Vendor", treasurer: "Treasurer" };
const fmt = (ms) => { const s = Math.max(0, Math.floor(ms / 1000)); return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`; };

export function ViewAsBanner({ user, onExit }) {
  const exp = user?.view_as?.expires_at || localStorage.getItem("view_as_expires_at");
  const [left, setLeft] = useState(() => (exp ? new Date(exp).getTime() - Date.now() : 0));
  useEffect(() => {
    if (!exp) return undefined;
    const t = setInterval(() => setLeft(new Date(exp).getTime() - Date.now()), 1000);
    return () => clearInterval(t);
  }, [exp]);
  const warning = left > 0 && left <= 2 * 60 * 1000;
  return (
    <div className={`${warning ? "bg-red-500 text-white" : "bg-amber-500 text-black"} py-2 px-4 sm:px-6 flex items-center gap-3 sticky top-0 z-30 shadow-md transition-colors`} data-testid="impersonation-banner" role="status">
      <Lock className="w-4 h-4 shrink-0" />
      <div className="text-xs sm:text-sm font-semibold tracking-wide min-w-0 truncate">
        Viewing as <span className="font-black" data-testid="viewas-name">{user?.name || user?.email}</span>
        {user?.role ? <> ({ROLE_LABEL[user.role] || user.role}{user?.is_kit_admin ? " · Kit Admin" : ""})</> : null}
        <span className="hidden sm:inline"> · read-only</span>
        {exp && <> · <span className="font-mono tabular-nums" data-testid="viewas-countdown">{fmt(left)}</span> left</>}
        {warning && <span className="ml-2 uppercase tracking-widest text-[10px]" data-testid="viewas-warning">ending soon</span>}
      </div>
      <div className="flex-1" />
      <button onClick={onExit} data-testid="exit-impersonation"
        className={`text-xs sm:text-sm px-3 py-1 rounded-full font-semibold tracking-widest uppercase whitespace-nowrap ${warning ? "bg-white text-red-600 hover:bg-red-50" : "bg-black text-amber-300 hover:bg-neutral-900"}`}>
        Exit view-as
      </button>
    </div>
  );
}
